import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const prijsvoorbeelden = [
  { product: 'Koffiebekers (bedrukt)', prijs: '€0,16 – €0,20', icon: 'ri-cup-line', populair: true },
  { product: 'Servetten / tissues (Bedrukt)', prijs: 'vanaf €0,025', icon: 'ri-file-paper-2-line', populair: false },
  { product: 'Bedrukte T-Shirts', prijs: 'vanaf €3,00', icon: 'ri-pages-line', populair: false },
  { product: 'Dozen (Bedrukt)', prijs: '€0,21 – €0,35', icon: 'ri-archive-line', populair: false },
  { product: 'Draagtassen (Bedrukt)', prijs: 'vanaf €0,20', icon: 'ri-shopping-bag-line', populair: false },
  { product: 'Zoekt u iets specifieks?', prijs: 'Vraag offerte aan', icon: 'ri-tools-line', populair: false },
];

export default function WatDoenWij() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="diensten" ref={ref} className="py-12 md:py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-10">
        <div className="text-center mb-8 md:mb-12">
          <motion.span initial={{ opacity: 0, y: 16 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5 }} className="inline-flex items-center gap-2 border border-[#3B9EE8]/40 bg-[#3B9EE8]/10 rounded-full px-4 py-2 text-[#3B9EE8] text-sm font-600 mb-6">
            <i className="ri-price-tag-3-line" />
            Prijsvoorbeelden
          </motion.span>
          <motion.h2 initial={{ opacity: 0, y: 16 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.1 }} className="font-heading font-800 text-[#0A1628] text-3xl md:text-4xl mb-3">
            Voorbeeld
            <br />
            <span className="text-[#3B9EE8]">Fabrieksprijzen</span>
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 16 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.2 }} className="text-[#0A1628]/55 text-lg max-w-xl mx-auto">
            Vergelijk met jouw huidige leverancier. Alle prijzen zijn <strong>exclusief BTW (ex. BTW)</strong>.
          </motion.p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {prijsvoorbeelden.map((item, i) => (
            <motion.div key={item.product} initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.2 + i * 0.1 }} className={`relative rounded-xl p-5 border cursor-default group transition-all duration-300 ${item.populair ? 'bg-[#0A1628] border-[#3B9EE8]/40' : 'bg-[#F7F8FA] border-[#0A1628]/6 hover:border-[#3B9EE8]/30'}`}>
              {item.populair && (
                <div className="absolute top-3 right-3 bg-[#3B9EE8] text-white text-xs font-700 px-2 py-0.5 rounded-full">Populair</div>
              )}
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg mb-3 ${item.populair ? 'bg-[#3B9EE8]/20' : 'bg-[#0A1628]/6 group-hover:bg-[#3B9EE8]/10'} transition-colors`}>
                <i className={`${item.icon} text-[#3B9EE8] text-lg`} />
              </div>
              <h3 className={`font-600 text-sm mb-1.5 leading-snug ${item.populair ? 'text-white' : 'text-[#0A1628]'}`}>{item.product}</h3>
              <div className={`font-heading font-800 text-xl md:text-2xl ${item.populair ? 'text-[#3B9EE8]' : 'text-[#0A1628]'}`}>{item.prijs}</div>
              <div className={`text-xs mt-1.5 leading-snug ${item.populair ? 'text-white/50' : 'text-[#0A1628]/45'}`}>Ex. BTW &bull; DDP leverbaar</div>
            </motion.div>
          ))}
        </div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.7 }} className="bg-[#0A1628] rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-heading font-700 text-white text-xl md:text-2xl mb-2">Staat jouw product er niet bij?</h3>
            <p className="text-white/55 text-sm md:text-base">Wij kunnen vrijwel elk product leveren. Stuur je specificaties en ontvang binnen 24 uur een prijsindicatie.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button onClick={() => { const el = document.querySelector('#contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }} className="bg-[#3B9EE8] hover:bg-[#2D85C5] text-white font-700 text-sm px-7 py-3.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap">
              Ontvang prijsindicatie
            </button>
            <a href="https://wa.me/31624359162?text=Hi%20Shubam%2C%20ik%20wil%20graag%20meer%20informatie%20over%20inkopen%20uit%20China." target="_blank" rel="nofollow noreferrer" className="flex items-center justify-center gap-2 border border-white/20 hover:border-[#3B9EE8]/50 text-white hover:text-[#3B9EE8] font-600 text-sm px-7 py-3.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-line text-lg" />
              WhatsApp ons
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
